import React, { ReactNode } from 'react';
import { DefaultTheme, ThemeProvider } from 'styled-components';
import Footer from '~/components/Footer';
import { useIsPublicRouter } from '~/hooks/IsPublicRouter';
import usePersistedStateTheme from '~/hooks/usePersistedStateTheme';
import { store } from '~/store';
import dark from '~/styles/themes/dark';
import Header from '../components/templates/Header';
import Sidebar from '../components/templates/Sidebar';
import { Container, ContentWrapper } from './styles';

interface StateProps {
  children: ReactNode;
}

const Layout: React.FC = ({ children }) => {
  const [theme, setTheme] = usePersistedStateTheme<DefaultTheme>(
    'SKY_LGPD_theme',
    dark,
  );

  const { IsPublicRouter } = useIsPublicRouter();

  const { signed } = store.getState().auth;

  if (!signed || IsPublicRouter) {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Container className="wrapper">
        <Header />
        <Sidebar />
        <ContentWrapper className="content-wrapper">
          <section className="content section-layout">{children}</section>
          <Footer />
        </ContentWrapper>
      </Container>
    </ThemeProvider>
  );
};

export default Layout;
